import { gql } from '@apollo/client'

export const CREATE_PRICE_LIST = gql`
  mutation createPricingPlan($name: String!, $pricings: [PricingInput!]!) {
    createPricingPlan(input: { name: $name, pricings: $pricings }) {
      success
      errors
    }
  }
`
